<mat-progress-bar *ngIf="isLoading$ | async; else notLoadingBar" mode="indeterminate"></mat-progress-bar>

<ng-template #notLoadingBar>
    <mat-progress-bar></mat-progress-bar>
</ng-template>
